export default {
  methods: {
    createMilliseconds (value, kf) {
      if (value === '00') {
        return 0
      } else if (value[0] === '0') {
        return Number(value[1]) * kf
      } else {
        return Number(value) * kf
      }
    },
    totalSeconds (newVal) {
      const [hours, minutes, seconds] = newVal.split(':')
      const hToMill = this.createMilliseconds(hours, 3600000)
      const minToMill = this.createMilliseconds(minutes, 60000)
      const secToMill = this.createMilliseconds(seconds, 1000)
      const sum = hToMill + minToMill + secToMill
      return sum
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/createMilliseconds.js